module.exports = __webpack_public_path__ + "img/UTDEER-2.cf887612.jpg";